import LinkToDocusaurus from '../LinkToDocusaurus'
import { qaSummary } from '../../docs-routes'

const LinkToDashboardDoc = () =>
  <LinkToDocusaurus path={qaSummary}>
    Learn more about Exploratory Dashboard
  </LinkToDocusaurus>

export default LinkToDashboardDoc
